import axios from 'axios';

export const getScreenHosts = (token, page = 1, pageSize = 50) => {
    return axios.get(process.env.REACT_APP_API_URL + '/admin/screenHosts', {
        headers: { Authorization: token },
        params: { page, pageSize }
    });
};
